Ext.define('SA.view.sidebar.data.ImportsSearchResultList', {
    alias: 'widget.imports-search-result-list',
    extend: 'SA.view.SimpleContainer',

    getFilteredCount() {
        return Ext.Array.sum(this.getChildItems().map(list => list.getFilteredCount()));
    },

    setFilter(filter) {
        this.getChildItems().forEach(list => list.setFilter(filter));

        this.setVisible(!!this.getFilteredCount());
    }
});